"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnumValue = exports.isCountryCode = exports.isNotPopulatedId = exports.isNullOrEmpty = void 0;
const isNullOrEmpty = (str) => {
    if (!str) {
        return true;
    }
    if (str.trim().length === 0) {
        return true;
    }
    return false;
};
exports.isNullOrEmpty = isNullOrEmpty;
const isNotPopulatedId = (nmb) => {
    if (!nmb) {
        return true;
    }
    if (nmb <= 0) {
        return true;
    }
    return false;
};
exports.isNotPopulatedId = isNotPopulatedId;
const isCountryCode = (str) => {
    if (!str) {
        return false;
    }
    if (str.length !== 2) {
        return false;
    }
    return true;
};
exports.isCountryCode = isCountryCode;
const isEnumValue = (str, enumVariable) => {
    const enumValues = Object.values(enumVariable);
    return enumValues.includes(str);
};
exports.isEnumValue = isEnumValue;
